import { useDateTimeConfig } from '@treneo/shared/contexts';
import {
  convertDateFormatToDayjs,
  convertDateToIsoString,
  convertUtcToTimezone,
  formatDayjsToString,
  getLocalTimezone,
  isValidDayjs
} from '@treneo/shared/utils';

type Props = {
  date: Date | string;
  timezone?: string;
  format?: string;
  showTimezone?: boolean;
  useConfigFormat?: boolean;
};

export const DateInfo = ({
  date,
  timezone: targetTimezone,
  format,
  showTimezone = false,
  useConfigFormat = true
}: Readonly<Props>) => {
  const { dateFormat } = useDateTimeConfig();

  if (!date) {
    return <span></span>;
  }

  const dateString = convertDateToIsoString(date);
  const timezoneToUse = targetTimezone ?? getLocalTimezone();
  const dayjsDate = convertUtcToTimezone(dateString, timezoneToUse);

  if (!isValidDayjs(dayjsDate)) {
    return <span></span>;
  }

  let formatted: string;

  if (useConfigFormat && !format) {
    const dayjsDateFormat = convertDateFormatToDayjs(dateFormat);
    formatted = formatDayjsToString(dayjsDate, dayjsDateFormat);
  } else {
    const formatToUse = format ?? 'YYYY-MM-DD';
    formatted = formatDayjsToString(dayjsDate, formatToUse);
  }

  const displayText =
    showTimezone && targetTimezone ? `${formatted} (${targetTimezone})` : formatted;

  return <span>{displayText}</span>;
};
